// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2748fe80","488":"5a1a13fd"}[chunkId] + ".chunk.js";
};